import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useEffect, useState } from "react";
import {
  GeoJSON,
  LayersControl,
  MapContainer,
  Marker,
  Popup,
  TileLayer,
} from "react-leaflet";
import Api from "../../../../../services/Api";
import Functions from "../../../../../services/Functions";
import CustomScaleControl from "../../../../general/CustomScaleControl";
import styles from "./GCMap.module.css";

function GCMap({
  distrito,
  category,
  subcategoria,
  natureza,
  selectedOption,
  searchInput,
  carroProprioValue,
  energiaEletricaValue,
  abastecimentoAguaValue,
  tipoFossaValue,
  descarteLixoValue,
  descarteEsgotoValue,
}) {
  const [informacoesPropriedades, setInformacoesPropriedades] = useState(null);
  const [districtData, setDistrictData] = useState(null);

  const comercialIcone = L.icon({
    iconUrl: "venda.png", // URL do ícone
    iconSize: [18, 18], // Tamanho do ícone
    iconAnchor: [16, 32], // Ponto de ancoragem (base do ícone)
    popupAnchor: [0, -32], // Posição do popup em relação ao ícone
  });

  const subsistenciaIcone = L.icon({
    iconUrl: "casa.png", // URL do ícone
    iconSize: [18, 18], // Tamanho do ícone
    iconAnchor: [16, 32], // Ponto de ancoragem (base do ícone)
    popupAnchor: [0, -32], // Posição do popup em relação ao ícone
  });

  const farmIcone = L.icon({
      iconUrl: "fazenda.png", // URL do ícone
      iconSize: [18, 18], // Tamanho do ícone
      iconAnchor: [16, 32], // Ponto de ancoragem (base do ícone)
      popupAnchor: [0, -32], // Posição do popup em relação ao ícone
    });

  const inscricao = Functions.getInscricaoParam(selectedOption, searchInput);
  const proprietario = Functions.getProprietarioParam(
    selectedOption,
    searchInput
  );

  function getIcon(natureza) {
    if (natureza === "01 - Comercial") {
      return comercialIcone;
    } else if (natureza === "02 - Subsistência") {
      return subsistenciaIcone;
    } else {
      return farmIcone;
    }
  }

  useEffect(() => {
    Promise.all([fetch("/distritos.geojson").then((res) => res.json())])
      .then(([districts]) => {
        setDistrictData(districts);
      })
      .catch((err) => console.error("Erro ao carregar GeoJSONs:", err));
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [informacoesPropriedades] = await Promise.all([
          Api.getLocalizacaoPropriedades2(
            distrito,
            category,
            subcategoria,
            natureza,
            inscricao,
            proprietario,
            carroProprioValue,
            energiaEletricaValue,
            abastecimentoAguaValue,
            tipoFossaValue,
            descarteLixoValue,
            descarteEsgotoValue
          ),
        ]);
        setInformacoesPropriedades(informacoesPropriedades);
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };
    fetchData();
  }, [
    distrito,
    category,
    subcategoria,
    natureza,
    inscricao,
    proprietario,
    carroProprioValue,
    energiaEletricaValue,
    abastecimentoAguaValue,
    tipoFossaValue,
    descarteLixoValue,
    descarteEsgotoValue,
  ]);

  function criarPopup(info) {
    return (
      <div style={{ fontFamily: "Arial, sans-serif", borderRadius: "5px" }}>
        {info.proprietario && (
          <div>
            <strong>Proprietário(a):</strong>
            <br />
            {info.proprietario}
          </div>
        )}
        {info.nome_propriedade && (
          <div style={{ marginTop: "6px" }}>
            <strong>Nome da Propriedade:</strong>
            <br />
            {info.nome_propriedade}
          </div>
        )}
        {info.localidade && (
          <div style={{ marginTop: "6px" }}>
            <strong>Localidade:</strong>
            <br />
            {info.localidade}
          </div>
        )}
        {info.area !== undefined && info.area !== null && (
          <div style={{ marginTop: "6px" }}>
            <strong>Área (ha):</strong>
            <br />
            {info.area.toFixed(2).replace(".", ",")}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={styles.gcMap}>
      <MapContainer
        center={[-20.4, -43.5]} // Coordenadas de São Paulo
        zoom={10}
        style={{ width: "100%", height: "100%" }}
      >
        <LayersControl position="topright">
          <LayersControl.BaseLayer checked name="Open Street Map">
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          </LayersControl.BaseLayer>

          <LayersControl.BaseLayer name="Carto BD">
            <TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" />
          </LayersControl.BaseLayer>

          <LayersControl.BaseLayer name="Esri Imagery/Satellite">
            <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" />
          </LayersControl.BaseLayer>

          <LayersControl.BaseLayer name="Esri Streets">
            <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}" />
          </LayersControl.BaseLayer>

          <LayersControl.BaseLayer name="Esri Topo">
            <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}" />
          </LayersControl.BaseLayer>

          <LayersControl.BaseLayer name="Google Maps">
            <TileLayer url="http://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}" />
          </LayersControl.BaseLayer>

          <LayersControl.BaseLayer name="Google Satellite">
            <TileLayer url="http://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}" />
          </LayersControl.BaseLayer>

          <LayersControl.BaseLayer name="Google Satellite Hybrid">
            <TileLayer url="http://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}" />
          </LayersControl.BaseLayer>

          <LayersControl.BaseLayer name="OSM Cycle Map">
            <TileLayer url="https://tile.thunderforest.com/cycle/{z}/{x}/{y}.png?apikey=aab02ccbf1c34b07872e7e8dbfb5946a" />
          </LayersControl.BaseLayer>
        </LayersControl>

        <CustomScaleControl />

        {districtData && (
          <GeoJSON
            data={districtData}
            style={() => ({
              color: "black",
              weight: 2,
              dashArray: "6,6",
              fillColor: "transparent",
              fillOpacity: 0,
            })}
          />
        )}

        {informacoesPropriedades &&
          informacoesPropriedades.map((info, index) => (
            <Marker
              key={index}
              position={[info.latitude, info.longitude]}
              icon={getIcon(info?.natureza)}
            >
              <Popup>{criarPopup(info)}</Popup>
            </Marker>
          ))}
      </MapContainer>
    </div>
  );
}

export default GCMap;
